module.exports = __webpack_public_path__ + "img/crystal@2x.c6953e8.webp";